export function VerdictSignature() {
  return (
    <div
      data-testid="verdict-signature"
      style={{
        margin: "56px 0 32px",
        textAlign: "center",
        fontFamily: "var(--qv3-font-serif)",
        fontStyle: "italic",
        fontWeight: 300,
        fontSize: 48,
        color: "var(--qv3-gold)",
        letterSpacing: "-0.02em",
        lineHeight: 1,
      }}
    >
      Hōjin
    </div>
  );
}

export default VerdictSignature;
